import { render, staticRenderFns } from "./newProductDetilsBanner.vue?vue&type=template&id=4d429a1a&scoped=true"
import script from "./newProductDetilsBanner.vue?vue&type=script&lang=js"
export * from "./newProductDetilsBanner.vue?vue&type=script&lang=js"
import style0 from "./newProductDetilsBanner.vue?vue&type=style&index=0&id=4d429a1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d429a1a",
  null
  
)

export default component.exports